module.exports = __webpack_public_path__ + "img/pay_tag.3f5db1fd.png";